const tagDataList = {
  default: {
    shareTitle: '플레이존 : SBS play 앱이 새로워졌어요',
    shareDescription: 'SBS play를 소개합니다',
    shareImageUrl: 'https://program-image.cloud.sbs.co.kr/og/2025/sbs_event.png',
    currentUrl: 'https://www.sbs.co.kr/playzone',
    keywords: 'SBS,에스비에스,뉸,sbs온에어,sbs실시간,www.sbs.co.kr,sbs.co.kr,지상파,VOD 무료,SBS 드라마 무료,sbskorea,sbstv,sbs편성표,sbs 韓国,sbs korean,서울방송,Seoul Broadcasting System,플레이존,playzone,sbsapp,SBS앱,sbsplay앱'
  },
  event: {
    shareTitle: '플레이존 : SBS play 앱이 새로워졌어요',
    shareDescription: 'SBS play를 소개합니다',
    shareImageUrl: 'https://program-image.cloud.sbs.co.kr/og/2025/sbs_event.png',
    currentUrl: 'https://www.sbs.co.kr/playzone',
    keywords: 'SBS,에스비에스,뉸,sbs온에어,sbs실시간,www.sbs.co.kr,sbs.co.kr,지상파,VOD 무료,SBS 드라마 무료,sbskorea,sbstv,sbs편성표,sbs 韓国,sbs korean,서울방송,Seoul Broadcasting System,플레이존,playzone,sbsapp,SBS앱,sbsplay앱'
  }

};

export default function index(pageSection, pageCategory = '') {
  //console.log('pageSection> ' + pageSection);

  let result = { ...tagDataList['default'], ...tagDataList[pageSection] };

  return { ...result };
}

